export function isPlatformHostname(hostname: string): boolean {
  const normalized = hostname.toLocaleLowerCase("en-US");
  return normalized === "platform.verityconnect.app" || normalized === "platform.localhost" || normalized === "platform.test";
}

export type TenantSurface = "public" | "staff" | "school" | "presenter" | "exhibitor";

export function tenantSurface(root: Pick<HTMLElement, "getAttribute"> = document.documentElement): TenantSurface | null {
  const value = root.getAttribute("data-tenant-surface");
  return value === "public" || value === "staff" || value === "school"
    || value === "presenter" || value === "exhibitor" ? value : null;
}
